import React, { useEffect, useState } from "react";
import "./Landing.css";

import activityImg from "../../assets/jackrussel_tryagain.svg";
import lastActivity from "../../assets/activity_on.svg";
import profileIcon from "../../assets/profile.svg";
import clinicalRecordIcon from "../../assets/clinical_record.svg";
import clinicalRecordIconBlue from "../../assets/clinical_record_blue-01.svg";
import currentLocationImg from "../../assets/currentLocation.svg";
import medicinesIconBlue from "../../assets/Drugs_icon_blue.svg";
import snackIcon from "../../assets/snack.svg";
import arrowIcon from "../../assets/arrow_blue-01.svg";
import downloadIcon from "../../assets/download-icon-blue.svg";
import deadlinesIcon from "../../assets/deadlines.svg";
import dietIcon from "../../assets/diet.svg";
import dietIconBlue from "../../assets/Diet_blue-01.svg";
import xmark from "../../assets/xmark-solid.svg";
import documentPdf from "../../assets/PDF-icon-1.svg";
import documentImg from "../../assets/JPG-icon.svg";
import documentEmpty from "../../assets/extension-empty-icon.svg";
import documentIcon from "../../assets/file_on.svg";
import profileEmpty from "../../assets/jackrussel_default.svg";
import addIcon from "../../assets/add_button.svg";
import loader from "../../assets/memopet-loader.json";

import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { triggerBase64Download } from "common-base64-downloader-react";
import { useGetPetInfo } from "../../api/pet";
import { useRecoilState, useRecoilValue } from "recoil";
import { accessTokenState } from "../../recoil/atom/accessTokenState";
import useFullPet from "../../hooks/useFullPet";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { languageState } from "../../recoil/atom/languageState";
import dictionary from "../../dictionaries/dictionaries.json";
import Lottie from "lottie-react";
import moment from 'moment-timezone';

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);

export const optionsDoughnut = {
	cutout: 110,
};

const Landing = (props) => {
	const [lang, setLang] = useRecoilState(languageState);
	const accessToken = useRecoilValue(accessTokenState);
	const { data, isLoading } = useGetPetInfo(accessToken, props.route);
	const { startActivity, endActivity, deleteActivity, downloadDocument, getTodayActivity, getActivityTypeCollection, todayActivityPost, currentLocation } = useFullPet();
	const [handleModal, setHandleModal] = useState(true);
	const [bottomModal, setBottomModal] = useState({ id: null, value: "" });
	const [downloadLoader, setDownloadLoader] = useState(0);
	const [sendCurrentLocationLoader, setSendCurrentLocationLoader] = useState(0);
	const [activityTypeCollection, setActivityTypeCollection] = useState();
	const [todayActivity, setTodayActivity] = useState();
	const [todayActivityModal, setTodayActivityModal] = useState(false);
	const [errorOnTodayActivity, setErrorOnTodayActivity] = useState(false);
	const greyDoughnutData = data?.data?.petVisibilityFiltered?.activitiesNumber * data?.data?.petVisibilityFiltered?.targetDailyActivity - data?.data?.fullActivity?.byDay.total;
	const purpleDoughnutData = data?.data?.fullActivity?.byDay?.total;

	useEffect(() => {
		!!data?.data?.petVisibilityFiltered?.id && updateTodayActivity();
		getActivityTypeCollection(accessToken).then((res) => {
			setActivityTypeCollection(res.data);
		});
		// let offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
		// setTimezone((offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2));
	}, [data]);

	// const handleLocationClick = () => {
	// 	if (navigator.geolocation) {
	// 		navigator.geolocation.getCurrentPosition(success, fnError);
	// 	} else {
	// 		toast.success(translate('geolocationNotSupported'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
	// 	}
	// };
	
	// const success = (position) => {
	// 	currentLocation(accessToken, data?.data?.petVisibilityFiltered?.id, position.coords.latitude, position.coords.longitude, `${translate('positionTextPt1')} ${translate('positionTextPt2')}`)
	// 	.then((res) => {
	// 		toast.success(translate('positionToastSuccess'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
	// 	})
	// 	.catch((err) => {
	// 		toast.warn(translate('positionToastError'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
	// 	})
	// 	.finally(() => {
	// 	});
	// };


	// const fnError = (err) => {
	// 	switch(err.code) {
	// 		case err.PERMISSION_DENIED:
	// 			toast.warn(translate('geolocationDisabled'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
	// 			break;
	// 		case err.POSITION_UNAVAILABLE:
	// 			toast.warn(translate('geolocationNotAvailable'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
	// 			break;
	// 		case err.TIMEOUT:
	// 			toast.warn(translate('geolocationTimedOut'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
	// 			break;
	// 		case err.UNKNOWN_ERROR:
	// 			toast.warn(translate('geolocationUnkownError'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
	// 			break;
	// 		default:
	// 			break;
	// 		}
	// };

	const getLocation = () => new Promise(function(resolve, reject) {
		navigator.geolocation.getCurrentPosition(resolve, reject);
	});

	const handleLocationClick = () => {
		getLocation()
		.then((res) => {
			currentLocation(accessToken, data?.data?.petVisibilityFiltered?.id, res.coords.latitude, res.coords.longitude, `${translate('positionTextPt1')} ${translate('positionTextPt2')}`)
			.then(() => {
				toast.success(translate('positionToastSuccess'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
			})
			.catch(() => {
				toast.warn(translate('positionToastError'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
			})
		})
		.catch((err) => {
			switch(err.code) {
				case err.PERMISSION_DENIED:
					toast.warn(translate('geolocationDisabled'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
					break;
				case err.POSITION_UNAVAILABLE:
					toast.warn(translate('geolocationNotAvailable'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
					break;
				case err.TIMEOUT:
					toast.warn(translate('geolocationTimedOut'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
					break;
				case err.UNKNOWN_ERROR:
					toast.warn(translate('geolocationUnkownError'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
					break;
				default:
					break;
				}
		})
		.finally(() => {
		})
	};

	const notify = () => {
		toast.warn(translate('activityDuration'), { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, closeButton: false, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
	};

	const dataDoughnut = {
		labels: [],
		datasets: [
			{
				label: "# of Votes",
				data: [purpleDoughnutData, greyDoughnutData],
				backgroundColor: ["#801950", "#BCBCBC"],
				borderColor: ["#801950", "#BCBCBC"],
				borderWidth: 1,
			},
		],
		options: {
			plugins: {
				legend: {
					position: "center",
					labels: {
						usePointStyle: true,
						textAlign: "center",
						useBorderRadius: true,
					},
				},
			},
		},
	};

	const plugins = [
		{
			beforeDraw: function (chart) {
				var width = chart.width,
					height = chart.height,
					ctx = chart.ctx;
				ctx.restore();
				var fontSize = (height / 120).toFixed(2);
				ctx.font = fontSize + "em sans-serif";
				ctx.textBaseline = "top";
				var text = `${Math.floor(purpleDoughnutData / 60)}h ${purpleDoughnutData}'`,
					textX = Math.round((width - ctx.measureText(text).width) / 2) + 3,
					textY = height / 2 - 20;
				ctx.fillText(text, textX, textY);
				ctx.save();
			},
		},
	];

	const startActivityOnClick = (petId) => {
		startActivity(accessToken, petId)
			.then((res) => {
				window.location.reload();
			})
			.catch((err) => {
				console.error("error on start activity", err);
			});
	};

	const endActivityOnClick = (activityId) => {
		endActivity(accessToken, activityId)
			.then((res) => {
				window.location.reload();
			})
			.catch((err) => {
				console.error("error on end activity", err);
			});
	};

	const deleteActivityOnClick = (activityId) => {
		deleteActivity(accessToken, activityId)
			.then((res) => {
				window.location.reload();
			})
			.catch((err) => {
				console.error("error on delete activity", err);
			});
	};

	const translate = (key) => (dictionary[lang] ?? dictionary["en"])[key ?? ""] ?? "";

	const goto = (url) => {
		window.location.replace(url);
	};

	const getDocumentImg = (path) => (path.includes(".pdf") ? documentPdf : path.includes(".jpe") ? documentImg : documentEmpty);

	const handleDocuments = async (id, name) => {
		setDownloadLoader(1);
		downloadDocument(accessToken, id)
			.then((res) => {
				triggerBase64Download(`data:${res.data.img}`, data.data?.petVisibilityFiltered.documents.find((el) => el.name === name).name || moment().format("YYYY-MM-DD-HH:mm:ss"));
			})
			.finally(() => {
				setDownloadLoader(0);
			});
	};

	const addTodayActivity = () => {
		setTodayActivityModal(true);
		disableBodyScroll(document.querySelector("#body"));
	};

	const updateTodayActivity = () => {
		getTodayActivity(accessToken, data?.data?.petVisibilityFiltered?.id)
			.then((res) => {
				setErrorOnTodayActivity(false);
				setTodayActivity(res.data);
			})
			.catch((err) => {
				setErrorOnTodayActivity(true);
				console.error("error on getTodayActivity", err);
			});
	};

	const addTodayActivityFromCollection = (id) => {
		todayActivityPost(accessToken, data?.data?.petVisibilityFiltered?.id, id, activityTypeCollection.find((el) => el.id === id)?.description, data?.data?.petVisibilityFiltered?.name).then((res) => {
			updateTodayActivity();
		});
	};

	const closeModal = () => {
		setTodayActivityModal(false);
		enableBodyScroll(document.querySelector("#body"));
	};

	let formatDate = (date) => {
		const matches = date.match(/(\d{2}:\d{2})/);
		return matches ? matches[0] : "";
	}

	if (!!isLoading || !!downloadLoader || !!sendCurrentLocationLoader) {
		return (
			<div className="loader-container">
				<Lottie className="loader" animationData={loader} loop={true} />
			</div>
		);
	} else {
		return (
			<div className="container-fluid" id="body">
				{!!todayActivityModal && <CustomSelect collection={activityTypeCollection} closeModal={() => closeModal()} addTodayActivityFromCollection={addTodayActivityFromCollection} backBtn={translate("back")} />}
				{data?.data?.responseType === 1 && (
					<div>
						<div className="d-flex align-items-center justify-content-center flex-column header">
							<div className="pet-container">
								<div className="pet-container-inner">
									<img
										src={!!data.data?.petVisibilityFiltered.img ? "data:" + data.data?.petVisibilityFiltered.img : profileEmpty}
										alt=""/>
								</div>
							</div>
							<div className="name">{data.data?.petVisibilityFiltered.name}</div>
						</div>

						{/* <div className="card-position row">
							<div className="col-6 d-flex justify-content-center align-items-center flex-column">
								<div className="card-text-position">Some text</div>
								<button className="sharePositionBtn" onClick={() => addTodayActivity()}>
									CONDIVIDI POSIZIONE
								</button>
							</div>
							<div className="col-6 p-0">
								<img className="imgCurrentPosition" src={currentLocation} alt="" />
							</div>
						</div> */}

						<div className="card-position d-flex justify-content-between align-items-center">
							<div className="ps-3 w-100 d-flex justify-content-center align-items-center flex-column">
								<div className="card-text-position">{translate("positionNotify")}</div>
								<button className="sendNotification" onClick={() => handleLocationClick()}>
									{translate("positionBtn")}
								</button>
							</div>
							<img className="imgCurrentPosition" src={currentLocationImg} alt=""/>
						</div>

						{/*						<div className="card">
							<div className="d-flex align-items-center justify-content-between">
								<span className="card-title">{translate("today")}</span>
							</div>
							<div className="w-100 customHrHeader"></div>
							<div className="d-flex justify-content-start align-items-center">
								<span className="w-100 card-text text-start">{translate("dailyDesc")}</span>
							</div>
							<div className="w-100 customHr"></div>
							{!errorOnTodayActivity && (
								<div>
									{todayActivity?.map((el) => (
										<div key={el?.id}>
											<div className="d-flex justify-content-start align-items-center">
												<span className="w-100 card-text text-start">{el?.motivationTypeDescription}</span>
												<span className="w-100 card-text text-end">
													{translate("hours")} {moment(el?.dateStart).format("HH:mm")}
												</span>
											</div>
											<div className="w-100 customHr"></div>
										</div>
									))}
									<button className="proceedBtn" onClick={() => addTodayActivity()}>
										<img src={addIcon} alt="" className="icon" />
										{translate("adds").toUpperCase()}
									</button>
								</div>
							)}
							{!!errorOnTodayActivity && (
								<div className="d-flex justify-content-start align-items-center flex-column">
									<span className="w-100 no-activity">{translate("error")}</span>
									<span className="w-100 no-activity">
										<a style={{ color: "#801950" }} href={`mailto:${translate("errorLink")}`}>
											{translate("errorLink")}
										</a>
									</span>
								</div>
							)}
						</div>*/}




						{!!data.data?.petVisibilityFiltered.ownerNumber && data.data?.petVisibilityFiltered.ownerNumber !== "" && (
							<div className="card-position d-flex justify-content-between align-items-center">
								<div className="w-100 h-100 ">
									<a href={"tel:" + data.data?.petVisibilityFiltered.ownerNumber}>
										<button className="sendNotification">
											{translate("callButton")}

								</button>
									</a>
							</div>
							</div>
							)}
						<div className="card">
							<div className="d-flex align-items-center justify-content-between">
								<span className="card-title">{translate("profile")}</span>
								<img src={profileIcon} alt="" className="icon"/>
							</div>
							<div className="w-100 customHrHeader"></div>
							{!!data.data?.petVisibilityFiltered.birth && data.data?.petVisibilityFiltered.birth !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("birth")}</span>
										<span
											className="w-100 card-text text-end">{moment(data.data?.petVisibilityFiltered.birth).format("DD-MM-YYYY")}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.bloodType && data.data?.petVisibilityFiltered.bloodType !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("bloodType")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.bloodType}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.breed && data.data?.petVisibilityFiltered.breed !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("breed")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.breed}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.color && data.data?.petVisibilityFiltered.color !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("color")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.color}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.eyeColor && data.data?.petVisibilityFiltered.eyeColor !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("eyeColor")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.eyeColor}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.gender && data.data?.petVisibilityFiltered.gender !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("gender")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.gender}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.weight && data.data?.petVisibilityFiltered.weight !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("weight")}</span>
										<span
											className="w-100 card-text text-end">{Math.round(data.data?.petVisibilityFiltered.weight)}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.heightAtWithers && data.data?.petVisibilityFiltered.heightAtWithers !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span
											className="w-100 card-text text-start">{translate("heightAtWithers")}</span>
										<span
											className="w-100 card-text text-end">{Math.round(data.data?.petVisibilityFiltered.heightAtWithers)}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.microchip && data.data?.petVisibilityFiltered.microchip !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("microchip")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.microchip}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.neckCircumference && data.data?.petVisibilityFiltered.neckCircumference !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span
											className="w-100 card-text text-start">{translate("neckCircumference")}</span>
										<span
											className="w-100 card-text text-end">{Math.round(data.data?.petVisibilityFiltered.neckCircumference)}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.ownerEmail && data.data?.petVisibilityFiltered.ownerEmail !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("ownerEmail")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.ownerEmail}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.ownerName && data.data?.petVisibilityFiltered.ownerName !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("ownerName")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.ownerName}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.ownerNumber && data.data?.petVisibilityFiltered.ownerNumber !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span
											className="w-100 card-text text-start">{translate("primaryContact")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.ownerNumber}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.passport && data.data?.petVisibilityFiltered.passport !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("passport")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.passport}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.species && data.data?.petVisibilityFiltered.species !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span className="w-100 card-text text-start">{translate("species")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.species}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.veterinaryBusinessName && data.data?.petVisibilityFiltered.veterinaryBusinessName !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span
											className="w-100 card-text text-start">{translate("veterinaryBusinessName")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.veterinaryBusinessName}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.veterinaryEmail && data.data?.petVisibilityFiltered.veterinaryEmail !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span
											className="w-100 card-text text-start">{translate("veterinaryEmail")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.veterinaryEmail}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered?.veterinaryNumber && data.data?.petVisibilityFiltered?.veterinaryNumber !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center">
										<span
											className="w-100 card-text text-start">{translate("veterinaryNumber")}</span>
										<span
											className="w-100 card-text text-end">{data.data?.petVisibilityFiltered.veterinaryNumber}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.address && data.data?.petVisibilityFiltered.address !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center flex-column">
										<span className="w-100 card-text text-start">{translate("address")}</span>
										<span
											className="w-100 card-text-address text-start">{data.data?.petVisibilityFiltered.address}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.ownerAddress && data.data?.petVisibilityFiltered.ownerAddress !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center flex-column">
										<span className="w-100 card-text text-start">{translate("ownerAddress")}</span>
										<span
											className="w-100 card-text-address text-start">{data.data?.petVisibilityFiltered.ownerAddress}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
							{!!data.data?.petVisibilityFiltered.veterinaryAddress && data.data?.petVisibilityFiltered.veterinaryAddress !== "" && (
								<div>
									<div className="d-flex justify-content-start align-items-center flex-column">
										<span
											className="w-100 card-text text-start">{translate("veterinaryAddress")}</span>
										<span
											className="w-100 card-text-address text-start">{data.data?.petVisibilityFiltered.veterinaryAddress}</span>
									</div>
									<div className="w-100 customHr"></div>
								</div>
							)}
						</div>
						{!!data.data?.petVisibilityFiltered.appointment?.length && (
							<div className="card">
								<div className="d-flex align-items-center justify-content-between">
									<span className="card-title">{translate("appointment")}</span>
									<img src={deadlinesIcon} alt="" className="icon"/>
								</div>
								<div className="w-100 customHrHeader"></div>
								{/* inner card */}
								{data.data?.petVisibilityFiltered.appointment.map((el) => (
									<div className="inner-card" key={el?.id}
										 onClick={() => setBottomModal({id: el?.id, value: "appointment"})}>
										<div className="d-flex align-items-center justify-content-between">
											<span className="card-title">{moment(el?.date).format("MMM DD YY")}</span>
											<span className="card-title">{moment(el?.date).format("HH:mm")}</span>
										</div>
										<div className="w-100 customHr"></div>
										<div className="d-flex justify-content-start align-items-start">
											<span className="inner-card-text">{el?.motivation}</span>
										</div>
									</div>
								))}
							</div>
						)}
						{!!data.data?.petVisibilityFiltered.medicalRecord?.length && (
							<div className="card">
								<div className="d-flex align-items-center justify-content-between">
									<span className="card-title">{translate("medicalRecord")}</span>
									<img src={clinicalRecordIcon} alt="" className="icon"/>
								</div>
								<div className="w-100 customHrHeader"></div>
								{data.data?.petVisibilityFiltered.medicalRecord.map((el) => (
									<div className="inner-card" key={el?.id}
										 onClick={() => setBottomModal({id: el?.id, value: "medicalRecord"})}>
										<div className="d-flex justify-content-between align-items-start">
											<img src={clinicalRecordIconBlue} alt="" className="icon"/>
											<span className="w-100 card-text">{el?.pathology?.description}</span>
											<img src={arrowIcon} alt="" className="icon"/>
										</div>
									</div>
								))}
							</div>
						)}
						{!!data.data?.petVisibilityFiltered.meal?.length && (
							<div className="card">
								<div className="d-flex align-items-center justify-content-between">
									<span className="card-title">{translate("meals")}</span>
									<img src={dietIcon} alt="" className="icon"/>
								</div>
								<div className="w-100 customHrHeader"></div>
								{data.data?.petVisibilityFiltered.meal.map((el) => (
									<div className="inner-card" key={el?.id}
										 onClick={() => setBottomModal({id: el?.id, value: "meal"})}>
										<div className="d-flex justify-content-between align-items-start">
											<img src={dietIconBlue} alt="" className="icon"/>
											<span className="w-100 card-text">{el?.name}</span>
											<img src={arrowIcon} alt="" className="icon"/>
										</div>
									</div>
								))}
							</div>
						)}

						{/*						<div className="card">
							<div className="d-flex align-items-center justify-content-between">
								<span className="card-title">{translate("tabHomeActivity")}</span>
								<img src={lastActivity} alt="" className="icon" />
							</div>
							<div className="w-100 customHrHeader"></div>
							{!!data.data?.petVisibilityFiltered.activities?.length && (
								<div>
									<div className="d-flex justify-content-between align-items-center">
										<span className="w-100 card-text">{translate("hourly")}</span>
										<span className="w-100 card-text">{translate("duration")}</span>
									</div>
									<div className="w-100 customHr"></div>

									<div className="d-flex justify-content-between align-items-center">
										<span className="w-100 card-text">{moment(data.data?.petVisibilityFiltered.activities[0]?.dateStart).format("HH:mm")}</span>
										<span className="w-100 card-text">
											{moment(data.data?.petVisibilityFiltered.activities[0]?.dateEnd).diff(data.data?.petVisibilityFiltered.activities[0]?.dateStart, "hours")}h{" "}
											{moment(data.data?.petVisibilityFiltered.activities[0]?.dateEnd).diff(data.data?.petVisibilityFiltered.activities[0]?.dateStart, "minutes")}'
										</span>
									</div>
								</div>
							)}
							{!data.data?.petVisibilityFiltered.activities?.length && (
								<div className="d-flex justify-content-between align-items-center">
									<span className="w-100 no-activity">{translate("noActivity")}</span>
								</div>
							)}
						</div>*/}

						{!!data.data?.petVisibilityFiltered.documents?.length && (
							<div className="card">
								<div className="d-flex align-items-center justify-content-between">
									<span className="card-title">{translate("documents")}</span>
									<img src={documentIcon} alt="" className="icon"/>
								</div>
								<div className="w-100 customHrHeader"></div>
								<div className="">
									{data.data?.petVisibilityFiltered.documents.map((el) => (
										<div key={el?.id} className="row d-flex align-items-center"
											 onClick={() => handleDocuments(el?.id, el?.name)}>
											<div
												className="col-3 col-sm-3 col-md-2 col-lg-1 col-xl-1 col-xxl-1 d-flex justify-content-start">
												<img src={getDocumentImg(el?.path)} alt="document" width="55"/>
											</div>
											<div
												className="col-6 col-sm-6 col-md-8 col-lg-10 col-xl-10 col-xxl-10 d-flex justify-content-start">
												<span className="card-text-document">{el?.name}</span>
											</div>
											<div
												className="col-3 col-sm-3 col-md-2 col-lg-1 col-xl-1 col-xxl-1 d-flex justify-content-end">
												<img src={downloadIcon} alt="document" width="20"
													 style={{marginRight: "5px"}}/>
											</div>
										</div>
									))}
								</div>
							</div>
						)}
					</div>
				)}
				{data?.data?.responseType === 0 && !!handleModal && (
					<div className="d-flex flex-column justify-content-center align-items-center containerActivity">
						<div className="activity">
							<div className="card-title-modal">{translate("newProduct").toUpperCase()}</div>
							<div className="card-title-modal">{translate("matchProduct")}</div>
							<div className="w-100 d-flex justify-content-center align-items-center">
								<img className="activityImg" src={activityImg} alt="" />
							</div>

							<div className="w-100 d-flex justify-content-center align-items-center flex-column">
								<button className="proceedBtn" onClick={() => goto("https://www.memopet.com")}>
									{translate("newProductDesc").toUpperCase()}
								</button>
							</div>
						</div>
					</div>
				)}
				{data?.data?.responseType === 2 && !!handleModal && (
					<div className="d-flex flex-column justify-content-center align-items-center containerActivity">
						<div className="activity">
							<div className="d-flex align-items-center justify-content-between w-100" onClick={() => setHandleModal(false)}>
								<div className="pet-container-activity">
									<div className="pet-container-activity-inner">
										<img src={!!data.data?.petVisibilityFiltered.img ? "data:" + data.data?.petVisibilityFiltered.img : profileEmpty} alt="" />
									</div>
								</div>
								<span className="card-text-activity">{data.data?.petVisibilityFiltered.name}</span>
								<div>
									<img className="closeModalActivity" src={xmark} alt="" />
								</div>
							</div>
							<div className="w-100 customHr-activity"></div>
							<div className="card-title">{translate("tapLeashTitleStart").toUpperCase()}</div>
							<div className="card-title">{translate("tapLeashDescStart")}</div>
							<div className="w-100 d-flex justify-content-center align-items-center">
								<img className="activityImg" src={activityImg} alt="" />
							</div>
							<div className="w-100 d-flex justify-content-center align-items-center flex-column">
								<button className="returnBtn" onClick={() => setHandleModal(false)}>
									{translate("back").toUpperCase()}
								</button>
								<button className="proceedBtn" onClick={() => startActivityOnClick(data?.data?.petVisibilityFiltered?.id)}>
									{translate("proceed").toUpperCase()}
								</button>
							</div>
						</div>
					</div>
				)}
				{data?.data?.responseType === 3 && !!handleModal && (
					<div className="d-flex flex-column justify-content-center align-items-center containerActivity">
						<div className="activity">
							<div className="d-flex align-items-center justify-content-between w-100" onClick={() => setHandleModal(false)}>
								<div className="pet-container-activity">
									<div className="pet-container-activity-inner">
										<img src={!!data.data?.petVisibilityFiltered.img ? "data:" + data.data?.petVisibilityFiltered.img : profileEmpty} alt="" />
									</div>
								</div>
								<span className="card-text-activity">{data.data?.petVisibilityFiltered.name}</span>
								<div>
									<img className="closeModalActivity" src={xmark} alt="" />
								</div>
							</div>
							<div className="w-100 customHr-activity"></div>
							<div className="card-title">{translate("tapLeashTitleStop").toUpperCase()}</div>
							<div className="card-title">
								{translate("duration")}: {moment().diff(data.data?.activity?.dateStart, "hours")}h {moment().diff(data.data?.activity?.dateStart, "minutes")}'
							</div>
							<div className="w-100 d-flex justify-content-center align-items-center">
								<img className="activityImg" src={activityImg} alt="" />
							</div>
							<div className="w-100 d-flex justify-content-center align-items-center flex-column">
								<button className="returnBtn" onClick={() => deleteActivityOnClick(data?.data?.activity.id)}>
									{translate("deleteActivity").toUpperCase()}
								</button>
								<button className="proceedBtn" onClick={() => (moment().diff(data.data?.activity?.dateStart, "minutes") < 1 ? notify() : endActivityOnClick(data?.data?.activity.id))}>
									{translate("finishTheActivity").toUpperCase()}
								</button>
							</div>
						</div>
					</div>
				)}

				<ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick closeButton={false} rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />

				{!handleModal && (
					<div className="container-chart d-flex justify-content-center align-items-center flex-column">
						<button className="back-to-activity" onClick={() => setHandleModal(true)}>
							{data?.data?.responseType === 3 ? translate("finishTheActivity").toUpperCase() : translate("tapLeashTitleStart").toUpperCase()}
						</button>
						<div className="card">
							<div className="d-flex align-items-center justify-content-between">
								<span className="card-title">{translate("today").toUpperCase()}</span>
								<img src={profileIcon} alt="" className="icon" />
							</div>
							<div className="w-100 customHrHeader"></div>
							<span className="w-100 card-text">
								{translate("todayActivityDesc1")}: {Math.floor(purpleDoughnutData / 60)}h {purpleDoughnutData}'
							</span>
							<div className="row legend-label">
								{data?.data?.fullActivity?.byDay?.total !== 0 && (
									<>
										<div className="col-5 d-flex justify-content-end align-items-center">
											<div className="legend-label-top"></div>
										</div>

										<div className="col-7 d-flex justify-content-start align-items-center">
											<div className="card-title">{translate("doghnutLabel2")}</div>
										</div>
									</>
								)}
								{greyDoughnutData !== 0 && (
									<>
										<div className="col-5 d-flex justify-content-end align-items-center">
											<div className="legend-label-bottom"></div>
										</div>
										<div className="col-7 d-flex justify-content-start align-items-center">
											<div className="card-title">
												{translate("doghnutLabel")}: {Math.floor(greyDoughnutData / 60)}h {greyDoughnutData}'
											</div>
										</div>
									</>
								)}
							</div>
							<div className="containerDoughnut">
								<Doughnut data={dataDoughnut} options={optionsDoughnut} plugins={plugins} />
							</div>
							<span className="w-100 card-text">{translate("weekActivityDesc2")}</span>
							<div className="container-resume">
								{data.data?.fullActivity?.byDay?.activitiesCollection.map((el) => (
									<div className="row" key={el?.startActivity}>
										<div className="col-3 d-flex justify-content-center align-items-center">
											<div className="card-title">{moment(el?.startActivity).format("H:mm")}</div>
										</div>
										<div className="col-2 d-flex justify-content-center align-items-center">
											<div className="circle"></div>
										</div>
										<div className="col-7 d-flex justify-content-center align-items-center">
											<div className="grey-card d-flex flex-column justify-content-end align-items-center">
												<div className="grey-card-text">
													{Math.floor(el?.duration / 60)}h {el?.duration}'
												</div>
												<div className="grey-card-text">
													{translate("start").toUpperCase()} {moment(el?.startActivity).format("H:mm")} {translate("end").toUpperCase()} {moment(el?.endActivity).format("H:mm")}
												</div>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				)}

				{!data && (
					<div className="d-flex flex-column justify-content-center align-items-center containerActivity">
						<div className="error404">
							<div className="card-title-error">
								{translate("error")} <a href={`mailto:${translate("errorLink")}`}>{translate("errorLink")}</a>
							</div>
							<div className="card-title-url">{`${window.location.hostname}${window.location.pathname}`}</div>
						</div>
					</div>
				)}

				{data?.data?.responseType === 4 && (
					<div className="d-flex flex-column justify-content-center align-items-center containerActivity">
						<div className="error404">
							<div className="card-title-error">
								{translate("error")} <a href={`mailto:${translate("errorLink")}`}>{translate("errorLink")}</a>
							</div>
							<div className="card-title-url">{translate("productNotRegistered")}</div>
							<div className="card-title-url">{`${window.location.hostname}${window.location.pathname}`}</div>
						</div>
					</div>
				)}

				{/* bottom modal */}

				{bottomModal?.value === "appointment" && (
					<div className="bottom-modal">
						<div className="d-flex align-items-end w-100 h-100">
							<div className="inner-bottom-modal">
								<div className="d-flex align-items-center justify-content-between">
									<span className="card-title-bottom-modal">{translate("appointment")}</span>
									<img src={xmark} alt="" className="icon-bottom-modal" onClick={() => setBottomModal({ id: null, value: null })} />
								</div>
								<div className="w-100 customHr"></div>
								{data.data?.petVisibilityFiltered?.appointment.map(
									(el) =>
										el?.id === bottomModal?.id && (
											<div key={el.id}>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("motivation").toUpperCase()}</span>
													<span className="text-bottom-modal">{el.motivation}</span>
													<div className="w-100 customHr"></div>
												</div>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("day").toUpperCase()}</span>
													<span className="text-bottom-modal">{moment(el?.date).format("MMM DD YY")}</span>
													<div className="w-100 customHr"></div>
												</div>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("hourly").toUpperCase()}</span>
													<span className="text-bottom-modal">{formatDate(el?.date)}</span>
													<div className="w-100 customHr"></div>
												</div>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("note")}</span>
													<div className="notes-bottom-modal d-flex justify-content-start">
														<span className="text-bottom-modal">{el.description}</span>
													</div>
												</div>
											</div>
										)
								)}
							</div>
						</div>
					</div>
				)}

				{bottomModal?.value === "medicalRecord" && (
					<div className="bottom-modal">
						<div className="d-flex align-items-end w-100 h-100">
							<div className="inner-bottom-modal">
								<div className="d-flex align-items-center justify-content-between">
									<span className="card-title-bottom-modal">{translate("pathology")}</span>
									<img src={xmark} alt="" className="icon-bottom-modal" onClick={() => setBottomModal({ id: null, value: null })} />
								</div>
								<div className="w-100 customHr"></div>
								{data.data?.petVisibilityFiltered?.medicalRecord.map(
									(el) =>
										el?.id === bottomModal?.id && (
											<div key={el.id}>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("name").toUpperCase()}</span>
													<span className="text-bottom-modal">{el?.pathology?.description}</span>
													<div className="w-100 customHr"></div>
												</div>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("pathology").toUpperCase()}</span>
													<span className="text-bottom-modal">{el?.pathology?.pathologyType?.description}</span>
													<div className="w-100 customHr"></div>
												</div>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("note")}</span>
													<div className="notes-bottom-modal d-flex justify-content-start">
														<span className="text-bottom-modal">{el?.posology}</span>
													</div>
												</div>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("drugs").toUpperCase()}</span>
													{el?.medicines?.map((x) => (
														<div key={x.id} className="d-flex justify-content-start align-items-center">
															<img src={medicinesIconBlue} alt="" width="25" style={{ marginRight: "5px" }} />
															<span className="text-bottom-modal">{x.description}</span>
														</div>
													))}
												</div>
											</div>
										)
								)}
							</div>
						</div>
					</div>
				)}

				{bottomModal?.value === "meal" && (
					<div className="bottom-modal">
						<div className="d-flex align-items-end w-100 h-100">
							<div className="inner-bottom-modal">
								<div className="d-flex align-items-center justify-content-between">
									<span className="card-title-bottom-modal">{translate("meal")}</span>
									<img src={xmark} alt="" className="icon-bottom-modal" onClick={() => setBottomModal({ id: null, value: null })} />
								</div>
								<div className="w-100 customHr"></div>
								{data.data?.petVisibilityFiltered?.meal.map(
									(el) =>
										el?.id === bottomModal?.id && (
											<div key={el.id}>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("name").toUpperCase()}</span>
													<span className="text-bottom-modal">{el?.name}</span>
													<div className="w-100 customHr"></div>
												</div>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("hourly").toUpperCase()}</span>
													<span className="text-bottom-modal">{formatDate(el?.timeMeal)}</span>
													<div className="w-100 customHr"></div>
												</div>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("note")}</span>
													<div className="notes-bottom-modal d-flex justify-content-start">
														<span className="text-bottom-modal">{el?.description}</span>
													</div>
												</div>
												<div className="d-flex justify-content-start align-items-start flex-column">
													<span className="title-bottom-modal">{translate("food").toUpperCase()}</span>
													{el?.dishes?.map((x) => (
														<div key={x.id} className="d-flex justify-content-start align-items-center">
															<img src={snackIcon} alt="" width="25" style={{ marginRight: "5px" }} />
															<span className="text-bottom-modal">{x.foodProduct.description}</span>
														</div>
													))}
												</div>
											</div>
										)
								)}
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
};

export default Landing;
